import { useQuery } from '@tanstack/react-query';
import { ITlpCountResponse } from '@legacy/apis/types/resourcePlannerAPI';
import { getFetch } from '@legacy/utils/fetcher';
import { TLP_PROJECT_COUNT_KEY } from '../constants';

const TLP_PROJECT_COUNT_URL_PATH =
  '/api/v2/resource-planner/tlp-all-project-count';

const resourcePlannerFetch = (): Promise<ITlpCountResponse> =>
  getFetch({ path: TLP_PROJECT_COUNT_URL_PATH, key: TLP_PROJECT_COUNT_KEY });

export const useGetTlpProjectCount = (enabled: boolean) => {
  const { data, ...restProps } = useQuery({
    enabled,
    queryFn: resourcePlannerFetch,
    queryKey: [TLP_PROJECT_COUNT_KEY],
  });

  return {
    count: data?.properties.count ?? 0,
    ...restProps,
  };
};
